import { useCallback, useEffect, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import { MODE_STORAGE_KEY, ModeContext, type Mode } from './modeContext';

const VALID_MODES: ReadonlyArray<Mode> = ['traditional', 'water', 'gamer'];

function getInitialMode(): Mode {
  if (typeof window === 'undefined') return 'traditional';
  const stored = window.localStorage.getItem(MODE_STORAGE_KEY);
  if (stored && (VALID_MODES as ReadonlyArray<string>).includes(stored)) {
    return stored as Mode;
  }
  return 'traditional';
}

export function ModeProvider({ children }: { children: ReactNode }) {
  const [mode, setModeState] = useState<Mode>(getInitialMode);

  useEffect(() => {
    try {
      window.localStorage.setItem(MODE_STORAGE_KEY, mode);
    } catch {
      /* ignora */
    }
  }, [mode]);

  const setMode = useCallback((next: Mode) => setModeState(next), []);
  const toggle = useCallback(
    (target: 'water' | 'gamer') =>
      setModeState((prev) => (prev === target ? 'traditional' : target)),
    [],
  );

  const value = useMemo(() => ({ mode, setMode, toggle }), [mode, setMode, toggle]);

  return <ModeContext.Provider value={value}>{children}</ModeContext.Provider>;
}
